import { render, staticRenderFns } from "./services-all.vue?vue&type=template&id=39ae1580"
import script from "./services-all.vue?vue&type=script&lang=js"
export * from "./services-all.vue?vue&type=script&lang=js"
import style0 from "./services-all.vue?vue&type=style&index=0&id=39ae1580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports